import styled from 'styled-components';
import { scrollbarStyle } from '@/utils';
import { CommunicationPanelProps } from './communicationPanel.types';

export const CommunicationPanelContainer = styled.div<{
  $panelPosition: CommunicationPanelProps['panelPosition'];
  $mode: CommunicationPanelProps['mode'];
}>`
  box-sizing: border-box;
  height: 100vh;
  width: ${({ $mode }) => ($mode === 'centered' ? '100vw' : '620px')};
  transition: width 0.5s;
  transition-timing-function: ease-in;
  position: absolute;
  top: 0;
  ${({ $panelPosition, $mode }) =>
    $panelPosition === 'left' || $mode === 'centered' ? 'left: 0;' : 'right: 0;'};
  padding: 100px 80px 40px 100px;
  background: ${({ theme }) => theme.color.ui8};
  display: flex;
  flex-direction: column;
  gap: 40px;

  ${({ $mode }) =>
    $mode === 'centered'
      ? `
  justify-content: center;
  align-items: center;
  `
      : ''};

  ${({
    theme: {
      color: { ui4, ui6 },
    },
  }) => scrollbarStyle(ui4, ui6, '4px', '0px')}
`;

export const CommunicationSidePanelContainer = styled.div<{
  $panelPosition: CommunicationPanelProps['panelPosition'];
}>`
  box-sizing: border-box;
  height: 100%;
  width: 620px;
  position: absolute;
  top: 0;
  ${({ $panelPosition }) => ($panelPosition === 'left' ? 'left: 0;' : 'right: 0;')};
  padding: 100px 80px 40px 100px;
  background: ${({ theme }) => theme.color.ui8};
  display: flex;
  flex-direction: column;
  gap: 40px;

  ${({
    theme: {
      color: { ui4, ui6 },
    },
  }) => scrollbarStyle(ui4, ui6, '4px', '0px')}
`;

export const CommunicationCenterPanelWrapper = styled.div`
  width: 100vw;
  height: 100vh;
  position: absolute;
  top: 0;
  left: 0;
  background: ${({ theme }) => theme.color.ui8};
  backdrop-filter: blur(8px);
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const CommunicationCenterPanelContainer = styled.div`
  display: flex;
  width: 420px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 40px;
  flex-shrink: 0;
  ${({
    theme: {
      color: { ui4, ui6 },
    },
  }) => scrollbarStyle(ui4, ui6, '4px', '0px')}
`;

export const CommunicationPanelLogoArea = styled.div<{
  $mode: CommunicationPanelProps['mode'];
}>`
  ${({ $mode }) => {
    if ($mode === 'sidePanel') {
      return `
  height: 82px;
  padding: 0px 20px 0px 0px;
  color: ${({ theme }) => theme.color.ui2};
  justify-content: left;
  `;
    }
  }}
`;
export const CommunicationPanelScrollableArea = styled.div<{
  $mode: CommunicationPanelProps['mode'];
}>`
  ${({ $mode }) => {
    if ($mode === 'sidePanel') {
      return `
      flex-grow: 1;
      overflow-y: auto;
    `;
    }
  }}

  box-sizing: border-box;
`;

export const CommunicationPanelContentArea = styled.div`
  display: flex;
  flex-direction: column;
  width: 420px;
  gap: 40px;
`;

export const Text = styled.div`
  ${({ theme }) => theme.font.t2};
  text-align: start;
`;
